import { t } from '@framework/i18n/intl/i18next.ts';
import { yup } from '@framework/validation/initYup.ts';
export interface EditModulesDelegationsValues {
  compilation: {
    enable: boolean;
    confirmUpdate: boolean;
    delegate?: string | null;
  };
  sign: {
    enable: boolean;
    confirmUpdate: boolean;
    delegate?: string | null;
  };
  view: {
    enable: boolean;
    confirmUpdate: boolean;
    delegate?: string[] | null;
  };
}

function addSchemaCondition(schema: yup.AnySchema) {
  return schema.when(
    ['confirmUpdate', 'enable'],
    ([confirm, enable]: boolean[], schema) => {
      // Se disabilitato, rimuovo il campo
      if (!enable) return schema.strip();
      // Se è confermata la modifica, il campo è obbligatorio
      if (confirm) return schema.required();
      return schema;
    },
  );
}

export const UpdateDelegationDataSchema = yup
  .object({
    /**
     * Indica che l'utente ha confermato la volontà di delegare un modulo
     */
    enable: yup
      .boolean()
      .required()
      .default(false)
      .label(
        t('update-delegation-data-schema.abilita-delega', 'Abilita delega'),
      ),
    /**
     * Indica che l'utente ha confermato la volontà di modificare
     * i delegati di moduli che precedentemente avevano delegati differenti
     */
    confirmUpdate: yup
      .boolean()
      .required()
      .default(false)
      .label(
        t(
          'update-delegation-data-schema.conferma-modifica',
          'Conferma Modifica',
        ),
      ),
    delegate: yup
      .string()
      .notRequired()
      .when(
        ['confirmUpdate', 'enable'],
        ([confirm, enable]: boolean[], schema) => {
          // Se disabilitato, rimuovo il campo
          if (!enable) return schema.strip();
          // Se è confermata la modifica, il campo è obbligatorio
          if (confirm) return schema.required();
          return schema;
        },
      )
      .label(t('update-delegation-data-schema.delegato', 'Delegato')),
  })
  .required()
  .noUnknown();

export const EditModulesDelegationsSchema: yup.ObjectSchema<EditModulesDelegationsValues> =
  yup
    .object({
      compilation: UpdateDelegationDataSchema.shape({
        delegate: addSchemaCondition(
          yup
            .string()
            .notRequired()
            .label(
              t(
                'edit-modules-delegation-schema.delegato-alla-compilazione',
                'Delegato alla compilazione',
              ),
            ),
        ),
      }),

      sign: UpdateDelegationDataSchema.shape({
        delegate: addSchemaCondition(
          yup
            .string()
            .notRequired()
            .label(
              t(
                'edit-modules-delegation-schema.delegato-alla-firma',
                'Delegato alla firma',
              ),
            ),
        ),
      }),

      view: UpdateDelegationDataSchema.shape({
        delegate: addSchemaCondition(
          yup
            .array()
            .of(yup.string().required())
            .notRequired()
            .label(
              t(
                'edit-modules-delegation-schema.delegati-alla-visualizzazione',
                'Delegati alla visualizzazione',
              ),
            ),
        ),
      }),
    })
    .required()
    .noUnknown();
